import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Lightbulb } from 'lucide-react';
import { axios, auth, mbUrl, muted, primary, runCall } from './mbApi';

const RESULT = { menang: 'Menang', kalah: 'Kalah', tak_pasti: 'Tak pasti (data belum cukup)' };
const RESULT_CLS = { menang: 'text-emerald-400', kalah: 'text-red-400', tak_pasti: 'text-amber-400' };

const fmt = (sn) => (sn ? `Join ${sn.joins ?? 0} (unik ${sn.joins_first ?? 0}) · CPS ${sn.cps_myr != null ? `RM ${sn.cps_myr.toFixed(2)}` : 'N/A'} · ${sn.days ?? 0} hari${sn.source === 'mock' ? ' · mock' : ''}` : '');

export const LearningPanel = ({ ibId, c, learnings, canWrite, suggestionId, reload }) => {
  const [f, setF] = useState({ result: 'tak_pasti', insight: '', next_action: '', implementation: '' });
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const save = () => runCall(setBusy, async () => {
    await axios.post(mbUrl(ibId, `/creatives/${c.id}/learning`), { ...f, suggestion_id: suggestionId || '' }, auth());
    setF({ result: 'tak_pasti', insight: '', next_action: '', implementation: '' });
    setOpen(false);
    reload();
  }, 'Pembelajaran direkod');

  return (
    <div className="space-y-1" data-testid={`mb-learning-${c.id}`}>
      {learnings.map((l) => (
        <div key={l.id} className={`text-[11px] ${muted} border-l-2 border-[hsl(var(--border))] pl-2`} data-testid={`mb-learning-item-${l.id}`}>
          <span className={RESULT_CLS[l.result]}>{RESULT[l.result]}</span> · <span className={primary}>{l.insight}</span>
          {l.next_action && <> · Next: {l.next_action}</>}
          {l.implementation && <> · {l.implementation === 'seperti_dicadangkan' ? 'Cadangan AI dilaksana seperti dicadangkan' : 'Cadangan AI: beberapa unsur berubah serentak'}</>}
          <span className="block">{l.author_name} · {new Date(l.created_at).toLocaleDateString('en-GB')} · {fmt(l.snapshot)}</span>
        </div>
      ))}
      {canWrite && !open && (
        <button className={`text-[11px] underline ${muted} flex items-center gap-1`} onClick={() => setOpen(true)} data-testid={`mb-learning-open-${c.id}`}>
          <Lightbulb size={11} /> Rekod Pembelajaran
        </button>
      )}
      {open && (
        <div className="flex flex-wrap gap-1.5" data-testid={`mb-learning-form-${c.id}`}>
          <Select value={f.result} onValueChange={(v) => setF({ ...f, result: v })}>
            <SelectTrigger className="h-7 w-48 text-xs" data-testid={`mb-learning-result-${c.id}`}><SelectValue /></SelectTrigger>
            <SelectContent>{Object.entries(RESULT).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
          </Select>
          <Input className="h-7 text-xs w-64" placeholder="Apa yang kita belajar? (contoh: hook soalan > hook angka)" value={f.insight} onChange={(e) => setF({ ...f, insight: e.target.value })} data-testid={`mb-learning-insight-${c.id}`} />
          <Input className="h-7 text-xs w-48" placeholder="Satu next action (contoh: buat V2 hook soalan)" value={f.next_action} onChange={(e) => setF({ ...f, next_action: e.target.value })} data-testid={`mb-learning-next-${c.id}`} />
          {suggestionId && (
            <Select value={f.implementation || 'x'} onValueChange={(v) => setF({ ...f, implementation: v === 'x' ? '' : v })}>
              <SelectTrigger className="h-7 w-60 text-xs" data-testid={`mb-learning-impl-${c.id}`}><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="x">Cadangan AI: pelaksanaan?</SelectItem>
                <SelectItem value="seperti_dicadangkan">Dilaksana seperti dicadangkan</SelectItem>
                <SelectItem value="beberapa_unsur_berubah">Beberapa unsur berubah serentak</SelectItem>
              </SelectContent>
            </Select>
          )}
          <Button size="sm" className="h-7 text-xs" disabled={busy || f.insight.trim().length < 5} onClick={save} data-testid={`mb-learning-save-${c.id}`}>Simpan</Button>
          <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => setOpen(false)}>Batal</Button>
          <p className={`w-full text-[10px] ${muted}`}>Result semasa (join, CPS, hari data) disimpan automatik sebagai snapshot. Data belum cukup? Pilih &quot;Tak pasti&quot; dan tulis apa perlu diuji lagi. Jangan cop &quot;Menang&quot; dengan 1-2 join je.</p>
        </div>
      )}
    </div>
  );
};
